import { AxiosError } from "axios";
import { useInfiniteQuery, UseInfiniteQueryResult } from "react-query";

import { fetchPaginatedPlaylistSongs } from "../lib/api";

export const playlistSongsQuery = (
  playlistId: string
): UseInfiniteQueryResult<ApiResponse<Songs>, AxiosError> => {
  return useInfiniteQuery<ApiResponse<Songs>, AxiosError>(
    ["playlist-songs", playlistId],
    ({ pageParam = 0 }) => fetchPaginatedPlaylistSongs(playlistId, pageParam),
    {
      enabled: !!playlistId,
      getNextPageParam: lastPage => {
        const currentPage = lastPage.paging?.currentPage;

        if (lastPage.data?.length > 9) {
          return parseInt(currentPage) + 1;
        }

        return undefined;
      }
    }
  );
};

export default function usePaginatedPlaylistSongs(
  playlistId: string
): UseInfiniteQueryResult<ApiResponse<Songs>, AxiosError> {
  return playlistSongsQuery(playlistId);
}
